export const getUserStatus = (status: string) => {
  if (status === 'BLOCK') return '이용정지';
  if (status === 'WITHDRAW') return '탈퇴';
  return '정상';
};
